import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getClaimLidLabelListEffect } from '../Claims/LossAndDamage/LossAndDamageClaimsEffects';
import { setLDClaimLidLabelList } from '../common/CommonActions';

const useClaimsLidLabelList = () => {
  const [list, setList] = useState(undefined);
  const { LDLidLabel } = useSelector((state) => state.common);
  const dispatch = useDispatch();

  // biome-ignore lint/correctness/useExhaustiveDependencies: fix this
  useEffect(() => {
    if (LDLidLabel.success) {
      setList(LDLidLabel.data);
    } else {
      getList();
    }
  }, [LDLidLabel]);

  const getList = async () => {
    try {
      dispatch(setLDClaimLidLabelList({ data: [], success: true }));
      const { data } = await getClaimLidLabelListEffect();
      setList(data);
      dispatch(setLDClaimLidLabelList({ data, success: true }));
    } catch {
      setList([]);
    }
  };

  return list;
};

export default useClaimsLidLabelList;
